import _css from "@emotion/css";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React, { PureComponent } from 'react';
import { withContentTheme, styleReducerNoOp } from '../../../theme';

var SkeletonItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SkeletonItem, _PureComponent);

  function SkeletonItem() {
    _classCallCheck(this, SkeletonItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(SkeletonItem).apply(this, arguments));
  }

  _createClass(SkeletonItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hasBefore = _this$props.hasBefore,
          styleReducer = _this$props.styles,
          theme = _this$props.theme;
      var mode = theme.mode,
          context = theme.context;
      var defaultStyles = mode.skeletonItem()[context];
      var styles = styleReducer(defaultStyles);
      return ___EmotionJSX("div", {
        css:
        /*#__PURE__*/
        _css({
          '&&': styles.wrapper
        }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3ByZXNlbnRhdGlvbmFsL1NrZWxldG9uSXRlbS9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQlciLCJmaWxlIjoiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcHJlc2VudGF0aW9uYWwvU2tlbGV0b25JdGVtL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IFB1cmVDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IHdpdGhDb250ZW50VGhlbWUsIHN0eWxlUmVkdWNlck5vT3AgfSBmcm9tICcuLi8uLi8uLi90aGVtZSc7XG5cbmNsYXNzIFNrZWxldG9uSXRlbSBleHRlbmRzIFB1cmVDb21wb25lbnQge1xuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIGhhc0JlZm9yZTogZmFsc2UsXG4gICAgc3R5bGVzOiBzdHlsZVJlZHVjZXJOb09wLFxuICB9O1xuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7IGhhc0JlZm9yZSwgc3R5bGVzOiBzdHlsZVJlZHVjZXIsIHRoZW1lIH0gPSB0aGlzLnByb3BzO1xuXG4gICAgY29uc3QgeyBtb2RlLCBjb250ZXh0IH0gPSB0aGVtZTtcbiAgICBjb25zdCBkZWZhdWx0U3R5bGVzID0gbW9kZS5za2VsZXRvbkl0ZW0oKVtjb250ZXh0XTtcbiAgICBjb25zdCBzdHlsZXMgPSBzdHlsZVJlZHVjZXIoZGVmYXVsdFN0eWxlcyk7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjc3M9e3sgJyYmJzogc3R5bGVzLndyYXBwZXIgfX0+XG4gICAgICAgIHtoYXNCZWZvcmUgJiYgPGRpdiBjc3M9e3N0eWxlcy5iZWZvcmV9IC8+fVxuICAgICAgICA8ZGl2IGNzcz17c3R5bGVzLmNvbnRlbnR9IC8+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IHdpdGhDb250ZW50VGhlbWUoU2tlbGV0b25JdGVtKTtcbiJdfQ== */")
      }, hasBefore && ___EmotionJSX("div", {
        css: styles.before
      }), ___EmotionJSX("div", {
        css: styles.content
      }));
    }
  }]);

  return SkeletonItem;
}(PureComponent);

_defineProperty(SkeletonItem, "defaultProps", {
  hasBefore: false,
  styles: styleReducerNoOp
});

export default withContentTheme(SkeletonItem);